module.exports = __webpack_public_path__ + "img/scenario-ace.652b28ab.png";